import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * Renders a title grid cell.
 */
@Component({
	selector: 'grid-title-cell-renderer',
	templateUrl: './grid-title-cell-renderer.component.html',
	styleUrl: './grid-title-cell-renderer.component.css'
})
export class GridTitleCellRendererComponent implements ICellRendererAngularComp {
	trustedValue: SafeHtml = "";
	value: string = "";
	isVisited: boolean = false;
	recordId: number = 0;
	context: any; // Passed in through the parent gridOptions 

	constructor(
		private sanitizer: DomSanitizer
	) { }

	agInit(params: ICellRendererParams): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.value = params.value || '';
		this.trustedValue = this.sanitizer.bypassSecurityTrustHtml(this.value);
		
		this.recordId = params.data.id;
		this.context = params.context;
		this.isVisited = this.context.visited[this.recordId] || false;
		return true;
	}

	openRecord(event?: Event): void {
		if (event) event.stopPropagation();
		this.context.openRecord(this.recordId);
	}
}
